import React from 'react';
import { B, D, Arr, Lbl, Lane } from '../shared/SvgHelpers';

export default function DiagramQ3Workflow() {
  return (
    <div className="space-y-2" data-testid="diagram-q3-workflow">
      <h4 className="text-sm font-bold text-purple-700">Q3-Workflow — Werk-zu-Werk (intern)</h4>
      <p className="text-xs text-slate-500">Interne Reklamation zwischen zwei Produktionsstandorten — abgebendes Werk ist verantwortlich.</p>
      <svg viewBox="0 0 760 230" className="w-full rounded-lg border border-slate-200" style={{ background: '#fafbfc' }}>
        <Lane x={5} y={5} w={750} h={100} title="MATERIALFLUSS + PRÜFUNG" color="#2563eb" />
        <Lane x={5} y={115} w={750} h={105} title="Q3-ANLAGE + 8D-WORKFLOW + KOSTENVERRECHNUNG" color="#7c3aed" />

        {/* Flow oben */}
        <B x={20} y={28} w={110} h={42} label={"Werk A produziert\n(Abgebend)"} color="#2563eb" />
        <Arr x1={130} y1={49} x2={165} y2={49} />
        <B x={165} y={28} w={95} h={42} label={"Transport\n/ Lagerung"} color="#64748b" />
        <Arr x1={260} y1={49} x2={295} y2={49} />
        <B x={295} y={28} w={110} h={42} label={"Werk B empfängt\n(Melder)"} color="#2563eb" />
        <Arr x1={405} y1={49} x2={440} y2={49} />
        <B x={440} y={28} w={115} h={42} label={"WQS-Eingangs-\nprüfung"} color="#d97706" />
        <Arr x1={555} y1={49} x2={590} y2={49} />
        <D x={615} y={49} s={26} label={"Fehler\nfestgestellt?"} color="#d97706" />

        {/* Nein */}
        <Arr x1={641} y1={49} x2={680} y2={49} />
        <Lbl x={648} y={42} text="Nein" color="#16a34a" />
        <B x={680} y={28} w={55} h={42} label={"OK ✓\nBuchen"} color="#16a34a" />

        {/* Ja → Q3 */}
        <Arr x1={615} y1={75} x2={615} y2={140} />
        <Lbl x={622} y={90} text="Ja" color="#dc2626" size={8} />

        {/* Q3-Workflow unten */}
        <B x={555} y={140} w={110} h={42} label={"Q3 anlegen\n(message_type=Q3)"} color="#7c3aed" />
        <Arr x1={555} y1={161} x2={510} y2={161} />
        <B x={405} y={140} w={105} h={42} label={"Abgebendes Werk\nverantwortlich"} color="#dc2626" />
        <Arr x1={405} y1={161} x2={360} y2={161} />
        <B x={255} y={140} w={105} h={42} label={"8D-Workflow\nD0-D8 Werk A"} color="#7c3aed" />
        <Arr x1={255} y1={161} x2={210} y2={161} />
        <B x={110} y={140} w={100} h={42} label={"Kosten →\nKST Werk A"} color="#dc2626" />
        <Arr x1={110} y1={161} x2={70} y2={161} />
        <B x={20} y={140} w={50} h={42} label={"Close"} color="#16a34a" />

        {/* Legende unten */}
        <rect x={20} y={195} width={720} height={18} rx={9} fill="#64748b" opacity={0.07} />
        <text x={380} y={208} textAnchor="middle" fontSize="9" fill="#475569">
          Meldefrist: 30 Arbeitstage ab Wareneingang · Bei verdeckten Fehlern: ab Entdeckung
        </text>
      </svg>
    </div>
  );
}
